module.exports = __webpack_public_path__ + "static/media/signup.e7fc5a09.svg";